import {HttpModelConverter} from "../../../core/converter/httpModel.converter";
import {Account} from "../../../../shared/model/account/account.model";
import {AccountSummaryConverter} from "./AccountSummary.converter";
import {UserSummaryConverter} from "../../modules/user/api/converter/userSummary.converter";

export class AccountConverter extends HttpModelConverter<Account> {

    protected createInstance(): Account {
        return new Account();
    }

    protected enrichObject(result: Account, src: Account) {
        result.summary = new AccountSummaryConverter().convert(src.summary);
        result.users = new UserSummaryConverter().convertFromArray(src.users);
    }


}